import React, { useState, useEffect, useRef } from "react";
import { SelectField, TextField, Button } from "react-md";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { MSpinner } from "components/Shared";
import TextBlock from "components/Shared/TextBlock";
import {
  setMultiFactorMethodsForUser,
} from "requests/profile";
import { normalizePhone } from "components/FormElements";
import MDialog, { ACTION_CLOSE } from "components/Shared/MDialog.tsx";

const SelectTwoFactorSetup = (props) => {
  const mounted = useRef(true);
  // Dropdown options for multi-factor selection
  const [multiFactorOptions, setMultiFactorOptions] = useState([]);
  // 2fa method selected by the user
  const [mutliFactorMethodSelection, setMutliFactorMethodSelection] = useState("");
  // 2fa setting option (i.e. phone number) selected by the user
  const [methodInputSelection, setMethodInputSelection] = useState("");

  const {
    profile,
    setDisplayCancelDialog,
    multiFactorMethods,
    multiFactorSetupResponse,
    setMultiFactorSetupResponse,
  } = props;

  useEffect(() => {
    if (multiFactorMethods.data.length && !multiFactorOptions.length) {
      setMultiFactorOptions(getOptions());
    } else if (multiFactorOptions.length && mutliFactorMethodSelection === "") {
      setMutliFactorMethodSelection(multiFactorOptions[0].value);
    }
    return () => {
      mounted.current = false;
    };
  }, []);

  let submitMultiFactorSetup = () => {
    let settings = {};
    if (methodInputRequired()) {
      settings = { PhoneNumber: { value: `${methodInputSelection}` } };
    }
    setMultiFactorSetupResponse({ data: null, isFetching: true });
    setMultiFactorMethodsForUser(profile.internetUserId, {
      multiFactorMethod: mutliFactorMethodSelection,
      removeMethod: false,
      settingsJson: JSON.stringify(settings),
    }, (s) => setMultiFactorSetupResponse({ data: s, isFetching: false }), mounted);
  };

  let onChange = (option) => {
    setMutliFactorMethodSelection(option);
  };

  let methodInputRequired = () => {
    return mutliFactorMethodSelection === "Text a verification code to my phone";
  };

  let getOptions = () => {
    const { data } = multiFactorMethods;
    if (!data.length) {
      return [];
    }

    return data.filter(s => !s.multiFactorMethodConfigured).map(s => {
      switch (s.multiFactorMethod) {
        case "Email a verification code":
          return { label: "Email A Verification Code", value: s.multiFactorMethod, preferred: false };
        case "Text a verification code to my phone":
          return { label: "Text A Verification Code", value: s.multiFactorMethod, preferred: true };
        case "Code is always 123456":
          return { label: s.multiFactorMethod, value: s.multiFactorMethod, preferred: false };
        default:
          break;
      }
    });
  };

  let setupActions = () => {
    let actions = [];
    if (!multiFactorSetupResponse.isFetching) actions.push({ code: ACTION_CLOSE, onClick: () => setDisplayCancelDialog(true), helpText: "Cancel" });
    return actions;
  };

  return (
    <MDialog
      id={"dialog-select-auth-method"}
      visible={true}
      actions={setupActions()}
      title={"Select Verification Method"}
      width={500} height={400}>
      <>
        {(!multiFactorMethods.data.length || multiFactorSetupResponse.isFetching) &&
          <div className="two-factor-setup-spinner">
            <TextBlock field={`Processing...`} />
            <MSpinner />
          </div>}
        {multiFactorOptions.length > 0 && !multiFactorSetupResponse.isFetching &&
          <div style={{ overflow: "none" }}>
            <SelectField
              id="selectMethod"
              menuItems={multiFactorOptions}
              value={mutliFactorMethodSelection}
              onChange={(curr) => onChange(curr)}
              itemLabel="label"
              itemValue="value"
              required
              label={"Verification Method:"}
              className="md-full-width"
            />
            {methodInputRequired() &&
              <TextField
                id="phoneNumber"
                label={"Phone Number"}
                value={methodInputSelection}
                onChange={val => setMethodInputSelection(normalizePhone(val))}
                required
                rows={1}
              />}
            <div className="verify-controls">
              <Button primary raised onClick={() => submitMultiFactorSetup()}>Continue</Button>
            </div>
          </div>}
      </>
    </MDialog>
  );
};

SelectTwoFactorSetup.propTypes = {
  profile: PropTypes.object,
  setDisplayCancelDialog: PropTypes.func,
  multiFactorMethods: PropTypes.object,
  multiFactorSetupResponse: PropTypes.object,
  setMultiFactorSetupResponse: PropTypes.func,
};

const mstp = state => ({
  profile: state.user.profile,
});

export default connect(mstp)(SelectTwoFactorSetup);